import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import User from "./User";
import Image from "../library/Image";
import UserNotification from "./UserNotification";
import Model from "./Model";
export class Notification extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'notification_id',
      fieldTitle: 'Notification id',
      content: null
    });
    _defineProperty(this, "audience", {
      fieldName: 'user_notifications',
      fieldTitle: 'Notification audience',
      model: UserNotification,
      content: []
    });
    _defineProperty(this, "type", {
      fieldName: 'notification_type',
      fieldTitle: 'Notification type',
      content: null
    });
    _defineProperty(this, "title", {
      fieldName: 'notification_title',
      fieldTitle: 'Notification title',
      content: null
    });
    _defineProperty(this, "description", {
      fieldName: 'notification_description',
      fieldTitle: 'Notification description',
      content: null
    });
    _defineProperty(this, "creationDate", {
      fieldName: 'created_at',
      fieldTitle: 'Notification Date',
      content: null
    });
    _defineProperty(this, "creator", {
      fieldName: 'notification_user',
      fieldTitle: 'Notification user',
      model: User,
      content: null
    });
  }
  getId() {
    return this.Id.content;
  }
  getTitle() {
    return this.title.content;
  }
  isSupport() {
    return this.type.content === Notification.SUPPORT_TYPE;
  }
  getDescription() {
    return this.description.content;
  }
  getDate() {
    return this.creationDate.content;
  }
  getType() {
    return this.type.content;
  }
  getCreator() {
    return this.creator.content;
  }
  getImage() {
    let user = this.getCreator();
    return user instanceof User ? user.getImage() : null;
  }
  getImageUrl() {
    let image = this.getImage();
    return image instanceof Image ? image.getUrl() : null;
  }
  getNotificationAudience() {
    var _this$audience$conten;
    return (_this$audience$conten = this.audience.content) !== null && _this$audience$conten !== void 0 ? _this$audience$conten : [];
  }
  isReadBy(user) {
    if (!(user instanceof User)) return false;
    let notificationsAudience = this.getNotificationAudience();
    return notificationsAudience.find(un => un instanceof UserNotification && un.getReadDate() && un.getCreatorId() === user.getId());
  }
  getCreatedAt() {
    return this.creationDate.content;
  }
  getResolvedTitle(vuetify) {
    var _exec;
    let data = (_exec = /^\$gen\$\.(.*)/.exec(this.getTitle())) === null || _exec === void 0 ? void 0 : _exec[1];
    if (!data) return this.getTitle();
    return vuetify.lang.t(['$vuetify.generic_text', data].join('.'));
  }
  getResolvedDescription(vuetify) {
    var _descriptionData;
    let data = /(?:\$gen\$\.)([^{]+)({.*})?/.exec(this.getDescription());
    if (!data) return this.getDescription();
    let descriptionName = data === null || data === void 0 ? void 0 : data[1];
    let descriptionData = null;
    try {
      descriptionData = JSON.parse(data === null || data === void 0 ? void 0 : data[2]);
    } catch (e) {}
    return vuetify.lang.t(['$vuetify.generic_text', descriptionName].join('.'), (_descriptionData = descriptionData) === null || _descriptionData === void 0 ? void 0 : _descriptionData.id);
  }
}
_defineProperty(Notification, "PRODUCT_TYPE", 'product');
_defineProperty(Notification, "OFFER_TYPE", 'offer');
_defineProperty(Notification, "INVOICE_TYPE", 'invoice');
_defineProperty(Notification, "SUPPORT_TYPE", 'support');
_defineProperty(Notification, "FEATURE_TYPE", 'feature');
_defineProperty(Notification, "OTHER_TYPE", 'other');
export default Notification;